import useFetch, { Status } from '../../../../../hooks/fetch.hook';

interface IMyTicket {
  id: string;
  title: string;
  description: string;
  validUntil: string;
}

export default function MyTickets() {
  // === STATE ===
  const [{ status, data, httpResponseStatusCode }] = useFetch<IMyTicket[]>('/api/mittkonto/mytickets');

  return (
    <div className="my-tickets">
      <h2>Mina biljetter</h2>
      {status === Status.loading && <p>Laddar...</p>}
      {status === Status.failed && httpResponseStatusCode === 401 && <p>Du är inte inloggad. Logga in för att se dina biljetter.</p>}
      {status === Status.failed && httpResponseStatusCode === 403 && <p>Du har inte behörighet att se dina biljetter.</p>}
      {status === Status.failed && httpResponseStatusCode !== 401 && httpResponseStatusCode !== 403 && <p>Något gick fel.</p>}
      {status === Status.success && data && (
        <ul>
          {data.map((ticket) => (
            <li key={ticket.id}>
              {ticket.title} — {ticket.description} (t.o.m. {ticket.validUntil})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
